var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.stateType === 'High')?_c('HighAnalitycsDashboard'):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }